import React from 'react'
import { Navbar, Nav } from 'react-bootstrap'
import { Link, animateScroll } from 'react-scroll'
import './NavBar.css'

const NavBar = () => {
  return (
    <Navbar
      data-aos="fade-down"
      data-aos-easing="ease-in-out-quart"
      data-aos-duration="1100"
      className="navBar"
      fixed="top"
      defaultActiveKey="home"
      variant="pills"
    >
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto ml-auto">
          <Link to="home" smooth={true} duration={800}>
            <Nav.Link href="#home" className="navItem" eventKey="home">
              <i
                className="fas fa-home logo"
                style={{ color: 'white' }}
                onClick={() => animateScroll.scrollToTop()}
              ></i>
            </Nav.Link>
          </Link>
          <Link to="skills" smooth={true} duration={800}>
            <Nav.Link className="navItem " eventKey="skills">
              <i class="fas fa-brain"></i> Skills
            </Nav.Link>
          </Link>
          <Link to="projects" smooth={true} duration={800}>
            <Nav.Link className="navItem " eventKey="projects">
              <i class="fas fa-project-diagram"></i> Projects
            </Nav.Link>
          </Link>
          <Link to="contact" smooth={true} duration={800}>
            <Nav.Link className="navItem" eventKey="contact">
              <i class="fas fa-envelope"></i> Contact
            </Nav.Link>
          </Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  )
}

export default NavBar
